import React from 'react'
import { Link } from 'react-router-dom'
import { Global } from 'utils/common'
import { useSelector } from 'react-redux'

export default function Logo({ collapsed }) {
	const { users } = useSelector(state => state.user)

	return (
		<Link to={Global.path.HOME} style={{ textAlign: 'center' }}>
			{
				users?.app_key != 'shopify' ? <img
					style={{
						width: 28,
						borderRadius: 10,
						marginLeft: 24,
						marginRight: 5
					}}
					src="logo.png?v=2"
					alt="logo"
				/> :
					<img
						style={{
							width: 48,
							borderRadius: 10,
							marginLeft: 24,
							marginRight: 5,
							border: '1px solid #ddd'
						}}
						src="logo.png"
						alt="logo"
					/>
			}

		</Link>
	)
}
